import { addYears, isAfter, isBefore, isEqual, startOfToday } from 'date-fns';

const formatDateOfBirthToDate = (foedselsdato: string): Date => {
    const year = Number.parseInt(foedselsdato.substring(4), 10);
    const month = Number.parseInt(foedselsdato.substring(2, 4), 10) - 1;
    const day = Number.parseInt(foedselsdato.substring(0, 2), 10);

    return new Date(year, month, day);
};

export const isOver18FromBirthDate = (date: string | Date | null | undefined): boolean => {
    if (date === null || date === undefined) {
        return true;
    }

    const dateString = date instanceof Date ? date.toISOString() : date;

    const dato = formatDateOfBirthToDate(dateString);
    const age = addYears(dato, 18);
    return isBefore(age, startOfToday()) || isEqual(age, startOfToday());
};

export const daysBetweenDates = (fromDate: Date, toDate: Date): number =>
    Math.ceil((toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24));

const padWithLeadingZero = (n: number) => {
    if (n < 10) {
        return `0${n}`;
    }

    return n;
};

// 1992-02-21
export const formatISODate = (date: Date) => {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const weekyear = date.getFullYear();

    return `${weekyear}-${padWithLeadingZero(month)}-${padWithLeadingZero(day)}`;
};

export const isUnder13 = (date: Date): boolean => isAfter(addYears(date, 13), startOfToday());
export const isUnder18 = (date: Date): boolean => isAfter(addYears(date, 18), startOfToday());
export const isOver18 = (date: Date): boolean => !isUnder18(date);
